import { render, staticRenderFns } from "./DeckSideInfo.vue?vue&type=template&id=bf3bffd2"
import script from "./DeckSideInfo.vue?vue&type=script&lang=ts"
export * from "./DeckSideInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports